module.exports = __webpack_public_path__ + "img/Button_DigiBos.c190b17f.png";